<template>
  <div class="pc-checkbox-input" :class="{checked: value, disabled: disabled}" @click="emitInput">
    <div class="pc-checkbox-input__icon" />
    <div class="pc-checkbox-input__text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcCheckboxInput',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitInput() {
      if(!this.disabled) {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-checkbox-input {
  display: flex;
  align-items: center;
  cursor: pointer;
  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
  &.checked {
    .pc-checkbox-input {
      &__icon {
        border-color: $active-green;

        &::after {
          background: $active-green;
        }
      }

      &__text {
        color: $black;
      }
    }
  }

  &__icon {
    margin-right: 10px;
    width: 28px;
    height: 28px;
    padding: 3px;
    border: 1px solid $gray-2;
    position: relative;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: "";
      width: 16px;
      height: 16px;
      border-radius: 3px;
      background: transparent;
    }
  }

  &__text {
    font-weight: 400;
    font-size: 16px;
    color: $gray-2;
  }
}
</style>
